import { memo } from "react"

import styled from "styled-components"

import { spacing, typography } from "@izettle/otto"

export const SelectOptionLoaderContainer = memo(styled.div`
  display: flex;
  outline: none;
  background: none;
  border: none;
  justify-content: center;
  min-height: fit-content;
  padding: ${spacing.xSmall};
  ${typography.smallCapsSecondary}
`)
